export enum TelematicsEvent {
  // Success statuses
  PhoneUsed = 1,
  Acceleration = 2,
  SpeedLimit = 3,
  HardBraking = 4,
  HardReturn = 5,
}
